export default __webpack_public_path__ + "static/media/playstation.775fbb69.svg";